import { CMSMenuLinksList } from './CMSMenuLinksList';

export default CMSMenuLinksList;
